import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, Typography, 
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Field, reduxForm, reset } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { styles } from '../styles';
import * as actions from '../../store/actions/members';
import Moment from 'moment';
import { subHeaderLabel, textLabelBold, isLoading } from "./meCommon";
import IcareLogo from "../../assets/images/icare_logo_transparent.png";

Moment.locale('en');

const validate = values => {
    const errors = {};
    const required = [];
    required.forEach((field, index) => {
        if (!values[field]) {
            errors[field] = 'Required';
        }
    });
    return errors;
};

const emailRegex = /^\w+([.-]?\w+)*@icarehealthplan.org/;

class ContactCenter extends Component {

    constructor(props){
        super(props);
        this.state = {
            email : '',
            error: { email: '' },
            emailVerificationCode: 0,
            showEmailVerification: false,
            isEmailVerified: false,
            showVerificationControls: false,
            disableEmailEdit: false,
        }
    }

    handleChange = (event) => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
        
        let value = event.target.value;
        let name = event.target.name;
        this.setState({[name]: value}, () => {
        switch(name){
            case "email":
                if (emailRegex.test(value)) {
                    this.setState({ error: {...this.state.error, email: ''}});
                } else {
                    this.setState({ error: {...this.state.error, email: 'Please enter a valid email.'}});
                }
                break;
            default: 
        }    
        });
    };

    renderTextField = (props) => {
        const {input, meta, label, isIcon, isDisabled, type, handleShow, error, required, multiline, ...custom} = props;
        return (
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={(required && meta.touched && meta.pristine) || error}
                helperText={required && meta.touched && ((meta.pristine && <span className="text-danger">{label} is Required</span>)
                || (error && <span className="text-danger">{error}</span>)
                || (meta.warning && <span>{meta.warning}</span>))}
                margin="normal"
                variant="outlined" 
                fullWidth={true} 
                disabled={isDisabled}            
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
                required={required}
                type={ type ? type : 'text' }  
            />
        );
    }    

    renderField = (name, label, value, required, error, password, isIcon, handleShow, isDisabled) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required}
                error={error} type={password} onChange={this.handleChange} isIcon={isIcon} handleShow={handleShow}
                isDisabled={isDisabled}
            />
        )
    }

    renderButton = (label, handler, disabled, variant, color) => {
        return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} disabled={disabled}>
                {label}
                {label === "Register" && <span style={{ paddingLeft: '10px' }}>
                    {this.props.loading && (
                        <CircularProgress size={16} thickness={2} color='inherit' />
                    )}
                </span>}
            </Button>
        );
    }

    resetProfile = () => {
        if(this.props.errorMessage) {
            this.props.dispatch(actions.resetErrorMsg);
        }
    }


    sendEmailVerificationCode = () => {
        let params = {};
        params.email = this.state.email;
        params.validationType = "contactcenter";
        this.props.dispatch(actions.getEmailVerificationCode(params, () => {
            this.setState({ showVerificationControls: true, disableEmailEdit: true, emailVerificationCode: 0 })
        }));
    }
    verifyEmail = () => {
        let params = {};
        params.email = this.state.email;
        params.verificationCode = this.state.emailVerificationCode;
        this.props.dispatch(actions.verifyEmail(params, () => {
            this.props.history.push('/getEmail');
        }));
    }
    handleEditEmail = () => {
        this.setState({ disableEmailEdit: false, emailVerificationCode: 0 });
        this.props.dispatch(reset('resetEmailForm'));
    }
    emailVerification = () => {
        const { email, emailVerificationCode, disableEmailEdit } = this.state;
        const { handleSubmit, loading } = this.props;
        return (
                <Fragment>
                    <Grid container spacing={2}>
                        <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ marginTop: "20px" }}>
                            {subHeaderLabel("Email Verification")}
                        </Grid>
                        <Grid item key={8} xs={12} sm={12} md={6} lg={6}>
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
                                {this.renderField('email', 'Email', email, true, this.state.error.email, "email", false, null, disableEmailEdit )}
                            </div>
                        </Grid>
                        <Grid item key={9} xs={12} sm={12} md={6} lg={6} style={{ alignItems: "center", display: "flex" }}>
                            {disableEmailEdit && this.renderButton('Edit', () => this.handleEditEmail(), loading, "text", "secondary")}
                        </Grid>
                        <Grid item key={10} xs={12} sm={12} md={6} lg={6}>
                            {disableEmailEdit && 
                            this.renderField('emailVerificationCode', 'Email Verification Code', emailVerificationCode, true, "", "number")}
                        </Grid>
                        <Grid item key={11} xs={12} sm={12} md={6} lg={6}></Grid>
                    </Grid>
                    <Grid item key={12} xs={12} sm={12} md={12} lg={12} >
                        {!disableEmailEdit && this.renderButton('Send verification Code', handleSubmit(this.sendEmailVerificationCode), !email || this.state.error.email || loading)}
                        {disableEmailEdit && this.renderButton('Verify', handleSubmit(this.verifyEmail), emailVerificationCode === 0 || loading)}
                    </Grid>
                    </Fragment>
                    )
    }

    renderErrorMessage = (errorMessage) => {
        return(
            <Grid container direction="column" justify="flex-start" alignItems="flex-start" style={{ padding: "10px", border: "1px solid rgb(227, 20, 20, .23)", marginBottom: "20px" }}>
                <Typography variant="body1">Please fix the below error to move forward: </Typography>
                <Typography variant="body1" color="error">{errorMessage} </Typography>
            </Grid>
            )
    }

    render() {
        const { classes, errorMessage, loading } = this.props;
        const { isEmailVerified } = this.state;
        return(
            <Grid container spacing={1} alignItems='center' justify='center'>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ height: "45px", backgroundColor: "#008675"}}></Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} style={{ margin: "0 45px", height: "110px"}}>
                    <Grid container direction="row" spacing={0}>
                        <Grid item key={1} xs={4} sm={4} md={4} lg={4}>
                            <Grid container direction="row" justify="center" alignItems="center">
                                <span className={classes.logo}>
                                    <img src={IcareLogo} alt="Icare" height="135px"/>
                                </span>
                            </Grid>
                        </Grid>
                        <Grid item key={2} xs={8} sm={8} md={8} lg={8} >
                            <Grid container direction="row" justify="flex-start" alignItems="center" style={{height: "135px", paddingLeft: "30px"}}>
                                {textLabelBold("h4", "Contact Center Self-Service for IDM")}
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={10} sm={10} md={9} lg={8} style={{ padding: "25px", marginTop: "40px"}}>
                    { errorMessage && this.renderErrorMessage(errorMessage)}
                    { !isEmailVerified && this.emailVerification()}
                    <Grid item key={38} xs={12} sm={12} md={12} lg={12}>
                        {loading && isLoading(loading)}
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

ContactCenter.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        errorMessage: state.members && state.members.errorMessage,
        email: state.members && state.members.email,
    };
};

ContactCenter = reduxForm({ 
    form: 'resetEmailForm' ,
    enableReinitialize: true,
    validate,
    fields: [
        'emailVerificationCode'
    ]
})(ContactCenter);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(ContactCenter); 